import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RegisterGuard {

  constructor(private route: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const role = this.authService.getRole();
    console.log("Role in register guard: ", role)
    if (role === 'guest') {
      return true;
    }
    this.route.navigateByUrl('/');
    return false;
  }

}
